import React, { useMemo } from 'react'
import { IntlProvider } from 'react-intl'
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl'
import initLocalization, { Localization } from 'lib/localization'
import { useAppSelector } from 'redux/toolkit/hooks'
import { FEATURES } from 'lib/splitioFeatures'
import KENDO_EN from 'config/i18n/kendo_en.json'
import KENDO_ES from 'config/i18n/kendo_es.json'
import KENDO_JA from 'config/i18n/kendo_jp.json'
import KENDO_FR from 'config/i18n/kendo_fr.json'
import KENDO_IT from 'config/i18n/kendo_it.json'
import KENDO_DE from 'config/i18n/kendo_de.json'
import KENDO_NL from 'config/i18n/kendo_nl.json'

const LocalizationProviderFix: any = LocalizationProvider

loadMessages(KENDO_EN, 'en')
loadMessages(KENDO_ES, 'es')
loadMessages(KENDO_JA, 'ja')
loadMessages(KENDO_FR, 'fr')
loadMessages(KENDO_IT, 'it')
loadMessages(KENDO_DE, 'de')
loadMessages(KENDO_NL, 'nl')

export const IntlWrapper = ({ children }: React.PropsWithChildren) => {
  const { language, isSplitioInitialized } = useAppSelector(_store => ({
    language: _store.app.language,
    isSplitioInitialized: Object.keys(_store.splitio?.treatments || {}).length === Object.keys(FEATURES).length
  }))
  // Re-initialize localization when Split.io becomes ready to pick up feature flags
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization: Localization = useMemo(() => initLocalization(language), [language, isSplitioInitialized])

  return (
    <IntlProvider locale={localization.locale} messages={localization.messages}>
      <LocalizationProviderFix language={localization.locale.substring(0, 2)}>{children}</LocalizationProviderFix>
    </IntlProvider>
  )
}
